import { BaseGeometry } from "./BaseGeometry";

export enum LayerObject {
	Side = 'Side',
	AreaType = 'Area Type',
	Area = 'Area',
	Section = 'Section',
	MaintenanceSection = 'MaintenanceSection'
}


export interface RimsLayer extends BaseGeometry {
	LocalID?: string; //This is a unique identifier only for use in the tree
	LayerType?: LayerObject;
	Colour?: string;
}

export interface AreaSection extends RimsLayer {
	// id: number;
	// name: string;
	areaTypeId: number;
	areaTypeName: string;
	areaId: number;
	areaName: string;
	sectionId: number;
	sectionName: string;
	// wkt: string;
}

export interface Polygon extends AreaSection {
	// id: number;
	// name: string;
	// wkt: string;
	// featureId: number;
	// addressSystemId: number;
}